import React, { Component } from 'react';
import { Popconfirm, message } from 'antd';
import TableC from '../../basicElement/TableC';
import { ApprovalHistory, ContractAttachment } from './PreviewModal';
import ProjectSideNav from '../../projectContract/SideNav';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import ReuseApprove from './ReuseApprove';
import SideNav from '../SideNav';
import Approve from './Approve';
import Filter from './Filter.js';
import Update from './Update';
import '../style.less';

class RequestRecord extends Component {
    state = {
        data: [],
        loading: false,
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        isAdd: false,
        businessList: [],
    }

    componentDidMount() {
        const { invId } = sessionStorage;
        if (invId > 0) {
            this.queryInvestigationStageByInvId(invId);
        }
        this.queryBusiness();
    }

    queryBusiness = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    loadData = () =>{
        const { sortParams, searchParams, pagination, pagination: { current, pageSize } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryJdeMainApply,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                ...sortParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { data, datas = [], totalCount } = res;
                const { isAdd } = data || {};
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                    isAdd,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = params => {
        const { pagination = {} } = this.state;
        pagination.current = 1;
        this.setState({
            searchParams: {...params},
            pagination
        }, () => {
            this.loadData();
        });
    }
    
    export = () => {
        const { sortParams, searchParams } = this.state;
        const url = API_URL.contract.exportJdeMainApply;
        ExportUtil.export({ ...sortParams, ...searchParams }, null, url);
    }

    queryInvestigationStageByInvId = (investigationId, callback) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    loading: false,
                    invStageList: data,
                }, () => {
                    callback && this.canEditByInvStatus(callback);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => [{
        title: '申请编号',
        dataIndex: 'jdeMainApplyCode',
        key: 'jdeMainApplyCode',
        fixed: 'left',
        width: 100,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        fixed: 'left',
        width: 160,
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    }, {
        title: '变更前JDE主项目号',
        dataIndex: 'originalContractCode',
        key: 'originalContractCode',
        width: 100,
        render: text => text ? text : '-',
    }, {
        title: '变更后JDE主项目号',
        dataIndex: 'afterAlterContractCode',
        key: 'afterAlterContractCode',
        width: 100,
    }, {
        title: '变更原因',
        dataIndex: 'alterReason',
        key: 'alterReason',
        width: 160,
    }, {
        title: '申请人',
        dataIndex: 'applyUserInfo',
        key: 'applyUserInfo',
        width: 120,
    }, {
        title: '申请时间',
        dataIndex: 'applyDateShow',
        key: 'applyDateShow',
        width: 100,
    }, {
        title: '申请状态',
        dataIndex: 'applyStatusShow',
        key: 'applyStatusShow',
        width: 120,
    }, {
        title: 'JDE主项目号变更时间',
        dataIndex: 'contractAlterDateShow',
        key: 'contractAlterDateShow',
        width: 100,
    }, {
        title: '操作',
        dataIndex: 'operate',
        key: 'operate',
        fixed: 'right',
        width: 140,
        render: (text, record) => {
            const { userId, curRole, investigationSiteName } = sessionStorage;
            const { applyStatus, applyBoUserId, applyBoUserIds, jdeMainApplyId, approvalHistoryIds, investigationId } = record;
            const canApprove = applyBoUserIds.some(el => el == userId);
            console.log(canApprove);
            const isPM = curRole == 'PM';
            const isBO = curRole == 'BO';
            const isFIN = curRole == 'FIN';
            const isSite = investigationSiteName === '中心汇总';
            const comDom = (
                <span>
                    <a onClick={() => this.showContractAttachment(record)}>查看附件</a>
                    <span className="ant-divider" />
                    <a onClick={() => this.showApprovalHistory(record)}>操作日志</a>
                </span>
            );
            if (isPM) {
                return (
                    <span>
                        {
                            isSite &&
                            <span>
                                {
                                    ((!approvalHistoryIds && applyStatus === 'BO_APPROVAL_APPLY') || applyStatus === 'BO_APPROVAL_DISAGREE' || applyStatus === 'FIN_APPROVAL_DISAGREE' || applyStatus === 'BO_MULTIPLEX_APPROVAL_DISAGREE') &&
                                    <span>
                                        <a onClick={() => this.queryInvestigationStageByInvId(investigationId, () => this.update(record))}>修改</a>
                                        <span className="ant-divider" />
                                    </span>
                                }
                                {
                                    (!approvalHistoryIds && applyStatus === 'BO_APPROVAL_APPLY') &&
                                    <span>
                                        <Popconfirm title="确定要撤销吗?" onConfirm={() => this.queryInvestigationStageByInvId(investigationId, () => this.delete(jdeMainApplyId))}>
                                            <a>撤销</a>
                                        </Popconfirm>
                                        <span className="ant-divider" />
                                    </span>
                                }
                            </span>
                        }
                        {comDom}
                    </span>
                );
            } else if (isBO) {
                return (
                    <span>
                        {
                            (applyStatus === 'BO_APPROVAL_APPLY' && canApprove) ?
                                <a onClick={() => this.queryInvestigationStageByInvId(investigationId, () => this.approve(record))}>审核</a>
                            :
                                <a disabled={true}>审核</a>
                        }
                        <span className="ant-divider" />
                        {
                            (applyStatus === 'BO_MULTIPLEX_APPROVAL' && userId == applyBoUserId) &&
                            <span>
                                <a onClick={() => this.canEditByInvStatus(() => this.reuseApprove(record))}>待BO复用审批</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        {comDom}
                    </span>
                );
            } else if (isFIN) {
                return (
                    <span>
                        {
                            (applyStatus === 'FIN_APPROVAL_APPLY') ?
                                <a onClick={() => this.queryInvestigationStageByInvId(investigationId, () => this.approve(record))}>审核</a>
                            :
                                <a disabled={true}>审核</a>
                        }
                        <span className="ant-divider" />
                        {comDom}
                    </span>
                );
            } else {
                return comDom;
            }
        }
    }]
    
    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    delete = (jdeMainApplyId) => {
        const options = {
            method: 'POST',
            url: API_URL.contract.deleteJdeMainApply,
            data: { jdeMainApplyId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    update = (record) => {
        this.updateRef.show(record);
    }

    approve = (record) => {
        this.approveRef.show(record);
    }

    reuseApprove = (record) => {
        this.reuseApproveRef.show(record);
    }

    showApprovalHistory = (record) => {
        this.approvalHistoryRef.show(record);
    }

    showContractAttachment = (record) => {
        this.contractAttachmentRef.show(record);
    }

    render() {
        const { data, isAdd, loading, pagination, businessList } = this.state;
        const { invState } = sessionStorage;
        return (
            <div className="content">
                {
                    invState == 1 ?
                        <ProjectSideNav selectKey='alterJdeCode' />
                    :
                        <SideNav selectKey='alterJdeCode' />
                }
                <div className="main">
                    <Filter isAdd={isAdd} search={this.search} export={this.export} update={this.update} businessList={businessList} canEditByInvStatus={this.canEditByInvStatus} />
                    <TableC
                        loading={loading}
                        pagination={pagination}
                        columns={this.getColumns()}
                        data={data}
                        scrollY={560}
                        onChange={this.handleTableChange}
                        rowKey="jdeMainApplyId"
                    />
                    <ApprovalHistory ref={el => this.approvalHistoryRef = el} />
                    <ContractAttachment ref={el => this.contractAttachmentRef = el} />
                    <Update ref={el => this.updateRef = el} loadData={this.loadData} />
                    <Approve ref={el => this.approveRef = el} loadData={this.loadData} />
                    <ReuseApprove ref={el => this.reuseApproveRef = el} loadData={this.loadData} />
                </div>           
            </div>
        )
    }
}

export default RequestRecord;


// WEBPACK FOOTER //
// ./src/components/contractManagement/alterJdeCode/index.js